<div class="banner">
  <h1>{{ 'rewards.nav.products' | translate }}</h1>
</div>

<fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>

<div class="container">
  <fgb-marketplace-list [isList]="true" [marketplaceItemTypes]="[4]" [productsItemView]="true"></fgb-marketplace-list>
</div>
